export default {
    searchText: 'ค้นหาชื่อวันหยุด',
    search: 'ค้นหา',
    holidayName: 'ชื่อวันหยุด',
    createdDate: 'วันที่สร้าง',
    holidayDate: 'วันหยุด',
    action: '',
    addHoliday: 'สร้างวันหยุด',
    deleteHeader: 'ลบวันหยุด',
    wantToDelete: 'คุณเเน่ใจว่าต้องการที่จะลบวันหยุด',
    congratulation: 'ยินดีด้วย',
    deletedHoliday: 'วันหยุดถูกลบแล้ว'
}
